import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=f55bc5f6&scoped=true&"
import script from "./WxLogin.vue?vue&type=script&lang=js&"
export * from "./WxLogin.vue?vue&type=script&lang=js&"
import style0 from "./WxLogin.vue?vue&type=style&index=0&id=f55bc5f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55bc5f6",
  null
  
)

export default component.exports